// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q8j2","fullView":"styles_fullView__29fCa"};